import React from 'react';

import classnames from 'classnames';

import { H1, H2, H3, H4, H5 } from '../../Typography';
import { Skeleton, type SkeletonProps } from '../Skeleton';

import styles from '../Skeleton.module.scss';

export type SkeletonTitleProps = Omit<SkeletonProps, 'height'> & {
    level: 1 | 2 | 3 | 4 | 5;
    compact?: boolean;
};
const componentsMap = {
    1: H1,
    2: H2,
    3: H3,
    4: H4,
    5: H5
};

export const SkeletonTitle = ({ className, level, compact, ...rest }: SkeletonTitleProps) => {
    const PlaceholderComponent = componentsMap[level as keyof typeof componentsMap] || H1;
    return (
        <Skeleton
            className={classnames(styles.title, styles[`level-${level}`], className)}
            {...rest}
            height={undefined}
        >
            <PlaceholderComponent
                className={styles.placeholder}
                aria-hidden="true"
                compact={compact}
            >
                loading
            </PlaceholderComponent>
        </Skeleton>
    );
};
